export class TipoQuestionario {
    public id: number;
    public denominacao: string;
    public extinto: boolean;
}
